<template>
    <div id="simNotice">
        <el-form :inline="true" :model="searchForm">
            <el-form-item label="弹窗标题：">
                <el-input v-model.trim="searchForm.title"  @keyup.enter.native="getNoticeList($event)" clearable></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" plain @click="getNoticeList($event)">查询</el-button>
                <el-button type="success" plain @click="showEditDialog(null)">新 增</el-button>
            </el-form-item>
            <p>PS：如果一个卡登录到APP，满足多个弹窗条件 则会按照时间顺序 取发布时间最近的一条展示</p>
        </el-form>

        <el-table :data="tbpg.tableData"
		border
		fit
		highlight-current-row
		style="width: 100%;margin-top: 20px;"
		:header-cell-style="{background:'#f5f5f5'}"
		>
            <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
            <el-table-column prop="title" label="标题" align="center"></el-table-column>
            <el-table-column prop="content" label="内容"  align="center"></el-table-column>
            <el-table-column prop="supplierNames" label="可见运营商" align="center"></el-table-column>
               <el-table-column prop="linkUrl" label="跳转链接"  align="center"></el-table-column>
             <el-table-column prop="stateName" label="状态"  align="center"></el-table-column>
            <el-table-column prop="createTime" label="发布时间" align="center"></el-table-column>
            <el-table-column label="操作" width="120" align="center" fixed="right">
                <template v-slot="scope">
                    <el-button type="text" @click="showDetail(scope.row)">内容详情</el-button>
                    <el-button type="text" @click="showEditDialog(scope.row)">修 改</el-button>
                </template>    
            </el-table-column>
        </el-table>
        
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>    


        <el-dialog :append-to-body="true"  title="内容详情" :visible.sync="detailVisible" width="600px" :close-on-click-modal="false">
            <div class="lineInDialog">
                <label>标题：</label>
                <span>{{ detail.title }} </span>
            </div>
            <div class="lineInDialog">
                <label>内容：</label>
                <span>{{ detail.content }} </span>
            </div>
            <div class="lineInDialog">
                <label>发布时间：</label>
                <span>{{ detail.createTime }} </span>
            </div>

            <div class="lineInDialog">
                <label>可见运营商名称：</label>
                <span>{{ detail.supplierNames }} </span>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="detailVisible = false">确 定</el-button>
            </div>            
        </el-dialog>


        <el-dialog :append-to-body="true"  title="编辑" :visible.sync="editVisibale"  width="600px"  class="notifyDetail" :close-on-click-modal="false" @close="cancel()">
            <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="140px">
                <el-form-item label="标题：" prop="title">
                    <el-input v-model="editForm.title"  clearable></el-input>
                </el-form-item>

                <el-form-item label="内容：" prop="content">
                    <el-input v-model="editForm.content"  clearable></el-input>
                </el-form-item>

                <el-form-item label="可见运营商名称："> 
                    <el-select v-model="editForm.supplierCodes" multiple  filterable 
                    placeholder="请选择" style="width: 80%;">
                        <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id" :label="item.name + '(' + item.alias + ')'"></el-option>
                    </el-select>
                    <el-button  @click="editForm.supplierCodes.length == branchSupplierOption.length?cancelChooseAll():chooseAll()" style="width: 18%; float: right;">
                        {{editForm.supplierCodes.length == branchSupplierOption.length?"取消全选":"全 选"}}
                    </el-button>
                </el-form-item>

                 <el-form-item label="跳转类型："> 
                    <el-select v-model="editForm.linkState"
                    placeholder="请选择" style="width: 80%;">
                        <el-option v-for="item in linkStateOption" :value="item.id" :key="item.id" :label="item.name "></el-option>
                    </el-select>
                </el-form-item>
                 <el-form-item label="跳转地址：" prop="content">
                    <el-input v-model="editForm.linkUrl"  clearable></el-input>
                </el-form-item>
                  <el-form-item label="状态："> 
                    <el-select v-model="editForm.state"
                    placeholder="请选择" style="width: 80%;">
                        <el-option v-for="item in stateOption" :value="item.id" :key="item.id" :label="item.name "></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel()">取 消</el-button>
                <el-button type="primary" @click="confirmHandler()">确 定</el-button>
            </div>
        </el-dialog>       

    </div>
</template>

<script>
import common from '@/utils/common.js'
export default {
    data(){
        return {  
            searchForm:{
                title:null,
            },
        linkStateOption:[
            {'id':3,'name':'跳转第三方链接'},
              {'id':4,'name':'跳转APP内部链接'}
        ],
         stateOption:[
            {'id':1,'name':'正常'},
              {'id':2,'name':'禁用'}
        ],
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },    

            detailVisible:false,
            detail:{
                title:null,
                content: null,
                createTime: null,
            },   

            branchSupplierOption: [],//运营商字典
            editVisibale: false,
            editForm:{
                id: null,
                title: null,
                content: null,
                linkUrl:null,
                state:null,
                supplierCodes: [],
                supplierNames: "",
                linkState:null
            },
            editRules: {
                title: { required: true, message: '请输入标题', trigger: 'blur' },
                content: {required: true, message: '请输入内容', trigger: 'blur'}
            },

        }
    },
    methods: {

        getNoticeList($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);        
            common.sysRequest('app/pc/notice/listPage', data, 'post').then(res=>{
                common.listCallback(this, res, 'tbpg');
            });
        },

        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getNoticeList();
        },
        handleCurrentChange(val){            
            this.tbpg.currentPage = val;
            this.getNoticeList();
        },

        showDetail(data){
            this.detail = data;
            this.detailVisible = true;
        },

        showEditDialog(data){
            if(data){
                this.editForm = data;
                this.editForm.supplierCodes = Array.isArray(data.supplierCodes)?data.supplierCodes:data.supplierCodes.split("，");
            }else{
                this.editForm = {
                    id: null,
                    title: null,
                    content: null,
                    linkUrl: null,
                    supplierCodes: [],
                    supplierNames: "",
                };
            }
            this.editVisibale = true;
        },

        chooseAll(){
            let val = [];
            for(let i in this.branchSupplierOption){
                val.push(this.branchSupplierOption[i].id);
            }
            this.editForm.supplierCodes = val;
        },
        cancelChooseAll(){
            this.editForm.supplierCodes = [];
        },

        confirmHandler(){
            this.$refs.editForm.validate(valid => {
                if(valid) {
                    let d = this.editForm;
                    d.supplierNames = "";
                    for(let j=0; j<d.supplierCodes.length; j++){
                        for(let i=0; i<this.branchSupplierOption.length; i++){
                            if(this.branchSupplierOption[i].id == d.supplierCodes[j]){
                                d.supplierNames += this.branchSupplierOption[i].name + '(' + this.branchSupplierOption[i].alias + ')，';
                                break;
                            }
                        }
                    }
                    d.supplierCodes = d.supplierCodes.join("，");
                    if(d.supplierNames.lastIndexOf('，') == d.supplierNames.length-1){
                        d.supplierNames = d.supplierNames.substring(0, d.supplierNames.length-1);
                    }
                    let path = "app/pc/notice/add";
                    if(d.id && d.id!=""){
                       path =  "app/pc/notice/update"
                    }
                    common.sysRequest(path, d, 'post').then(res => {
                        if(res.data.code == 200){
                            this.$message.success(res.data.message);
                            this.cancel();
                            this.getNoticeList();
                            
                        }else{
                           this.$message.error(res.data.message); 
                        }
                    })
                }
            });
        },

        cancel(){
            this.editForm = {
                id: null,
                title: null,
                content: null,
                linkUrl: null,
                supplierCodes: [],
                supplierNames: "",
            };
            this.editVisibale = false;
        },
    },
    created(){
        this.getNoticeList();
        common.getBranchSupplierOptionCom(this, 'branchSupplierOption');
    }
}
</script>

<style lang="less" scoped>
    .lineInDialog{
        label{
            width: 120px;
            font-weight: bold;
        }
    }
</style>

